import { useQuery } from '@tanstack/react-query';

import { getOfferingTransactionDocumentsForUser } from '@arrived/api_v2';
import { OfferingTransactionDocument, UserId } from '@arrived/models';

import { UseQueryOptions } from '../queries.utils';
import { userTradeDocumentsQueryKeyFn } from './trades.keys';

export function useUserTradeDocumentsQuery(userId?: UserId, options?: UseQueryOptions<OfferingTransactionDocument[]>) {
  return useQuery(userTradeDocumentsQueryKeyFn(userId!), async () => getOfferingTransactionDocumentsForUser(userId!), {
    ...options,
    enabled: (options?.enabled ?? true) && userId != null,
  });
}
